import { render } from "./SupervisorTrainingMaterialTab.vue?vue&type=template&id=db682f34"
import script from "./SupervisorTrainingMaterialTab.vue?vue&type=script&lang=js"
export * from "./SupervisorTrainingMaterialTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__